module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "js"
    }
  }, [_c('contentMenu'), _vm._v(" "), _c('javaScriptContent'), _vm._v(" "), _c('contentFooter')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29783c6e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/JavaScript.vue
// module id = 67
// module chunks = 0